import 'babel-polyfill'
import Vue from 'vue'

import Vuetify from 'vuetify'
import './stylus/main.styl'

import App from './App'
import * as firebase from 'firebase'
import router from './router'

import { store } from './store'
import DateFilter from './filters/date'

import AlertCmp from './components/Shared/Alert.vue'
import ViewContentDialog from './components/Content/ViewContentDialogue.vue'

import Swatches from 'vue-swatches'



// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.min.css"


Vue.use(Vuetify, {
  theme: {
    primary: '#00897b'
  }
})

Vue.config.productionTip = false
Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertCmp)
Vue.use(Swatches)


Vue.component('app-view-content-details-dialog', ViewContentDialog)




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created() {
    // Initialize Firebase
    var config = {
      apiKey: "AIzaSyDPiRD2_JIh9ap1gAh4mf3c1KNkFcbDFXU",
      authDomain: "the-loop-cb6ab.firebaseapp.com",
      databaseURL: "https://the-loop-cb6ab.firebaseio.com",
      projectId: "the-loop-cb6ab",
      storageBucket: "the-loop-cb6ab.appspot.com",
      messagingSenderId: "848554627148",
      
    };



    firebase.initializeApp(config);

  const firestore = firebase.firestore();
  const settings = {/* your settings... */ timestampsInSnapshots: true};
  firestore.settings(settings);

    //var provider = new firebase.auth.GoogleAuthProvider();

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        this.$store.dispatch('fetchUserData')
      }
    })

    //this.$store.dispatch('loadContents')
    this.$store.dispatch('loadPlaylists')

    this.$store.dispatch('loadTracks');
    this.$store.dispatch('loadSchedules')
    this.$store.dispatch('loadContents').then(() => {
        this.$store.dispatch('loadStatus');
      })
      //this.$store.dispatch('loadControls')
  }
})


// WEBPACK FOOTER //
// ./src/main.js